import { Component, Prop, Vue } from 'vue-property-decorator';
import { ContributionLevel } from '@/models';
import Tooltip from '@/components/common/tooltip/Tooltip.vue';

@Component({
  components: {
    Tooltip
  }
})
export default class ContributionLevelIcon extends Vue {
  @Prop({ default: () => ({} as ContributionLevel) }) contributionLevel: ContributionLevel;
}
